import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";

// The tap-to-edit store editor. Lazy-loaded so its bundle (Zustand, dnd-kit,
// schemas package, all inspectors) ships as a separate chunk and stays out of
// the seller portal's service-worker precache (2 MB limit).
//
// This is now the ONE editor: it serves the canonical `store/editor` route, and
// `store/editor/simple` is kept as an alias so older links keep working. The
// previous three-panel editor was removed once this reached parity.
const SimpleEditorPage = lazy(() =>
  import("./simple/pages/SimpleEditorPage").then((m) => ({
    default: m.SimpleEditorPage,
  })),
);

function EditorFallback() {
  return (
    <div className="flex h-full w-full items-center justify-center bg-[color:var(--background-muted)] text-sm text-[color:var(--text-muted)]">
      {"Loading editor…"}
    </div>
  );
}

const editorElement = (
  <Suspense fallback={<EditorFallback />}>
    <SimpleEditorPage />
  </Suspense>
);

/** Routes that live inside the editor's full-screen layout (no AppShell). */
export const storeEditorRoutes: RouteObject[] = [
  // Canonical route.
  { path: "store/editor", element: editorElement },
  // Back-compat alias — the editor used to live here while it ran in parallel
  // with the old three-panel editor.
  { path: "store/editor/simple", element: editorElement },
];
